import { render } from "./Demo4.vue?vue&type=template&id=7b7c3966&scoped=true&ts=true"
import script from "./Demo4.vue?vue&type=script&lang=ts"
export * from "./Demo4.vue?vue&type=script&lang=ts"

import "./Demo4.vue?vue&type=style&index=0&id=7b7c3966&lang=scss&scoped=true"

import exportComponent from "/Users/suhwanlim/Projects/pr/WorkoutHistory-Web/workout-history-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b7c3966"]])

export default __exports__